import { combineReducers } from "redux"

import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"

export const diagnosis = setterReducer("", t.SET_SIMPLE_FLOW_DIAGNOSIS)
export const cardinalEvidence = setterReducer({}, t.SET_CARDINAL_EVIDENCE)
export const active = setterReducer(false, t.SET_SIMPLE_FLOW_ACTIVE)
export const cardinalSubmitted = setterReducer(false, t.SET_CARDINAL_SUBMITTED)

export const cardinalResponses = (state = [], action) => {
  switch (action.type) {
    case t.SET_CARDINAL_RESPONSES:
      return action.payload.map((response, i) => ({ group: i, ...response }))
    case t.SHIFT_CARDINAL_RESPONSES:
      return state.slice(1)
    default:
      return state
  }
}

const simpleFlowReducers = combineReducers({
  active,
  cardinalEvidence,
  cardinalResponses,
  cardinalSubmitted,
  diagnosis,
})

export { simpleFlowReducers as default }



// WEBPACK FOOTER //
// ./assets/simpleFlow/reducer.js